import { render } from "./paymentUplift.vue?vue&type=template&id=7b3b809d"
import script from "./paymentUplift.vue?vue&type=script&lang=js"
export * from "./paymentUplift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__